import { HTTPResponse, IPaginationRequestQuery, IPaginationResponse } from '@/services/http/http.types.ts'
import http, { handleHttpError, handleHttpResponse } from '../../services/http'
import httpUtils from '@/services/http/http.utils'
import { ISystemEvent } from '@/pages/SystemEvents/systemEvents.types'

const list = httpUtils.createAbortableRequest(
  (
    signal,
    params: IPaginationRequestQuery & { type__in?: string; created_lte?: string; created_gte?: string }
  ): Promise<HTTPResponse<IPaginationResponse<ISystemEvent>>> => {
    return http.get('/nsi/v1/system-events', { signal, params }).then(handleHttpResponse).catch(handleHttpError)
  }
)

const recentCriticalEventsList = (): Promise<HTTPResponse<ISystemEvent[]>> => {
  return http.get('/nsi/v1/system-events/last-critical').then(handleHttpResponse).catch(handleHttpError)
}

interface ISystemEventsStatResp {
  totalEvents: number
  totalByType: [
    {
      _count: number
      type: 'ALARM_SITUATION_INCIDENT'
    },
    {
      _count: number
      type: 'SYSTEM_LOG'
    },
    {
      _count: number
      type: 'LP_ERROR'
    },
  ]
}
const getStats = (
  params: { created_lte?: string; created_gte?: string } = {}
): Promise<HTTPResponse<ISystemEventsStatResp>> => {
  return http.get('/nsi/v1/system-events/stats', { params }).then(handleHttpResponse).catch(handleHttpError)
}

const systemEventsApi = {
  list,
  getStats,
  recentCriticalEventsList,
}
export default systemEventsApi
